import React from 'react';
import { Flex, Box } from '../Rebass';
import styled from '@emotion/styled';
import theme from '../../theme';
import Icon from '../Icon';
import Text from '../Text';

interface FooterProps {
  children?: React.ReactNode;
  renderContact?: () => React.ReactNode;
  renderLegal?: () => React.ReactNode;
  renderSocial?: () => React.ReactNode;
  renderPPM?: () => React.ReactNode;
  bg?: string;
}

const StyledLegal = styled(Flex)`
  border-top: 1px solid ${theme.colors.borderDark};
`;

const StyledLegalLinks = styled(Flex)`
  i {
    font-size: 7px;
  }
`;

const Footer = ({
  children,
  renderContact,
  renderSocial,
  renderPPM,
  renderLegal,
  bg = 'bgLighter',
}: FooterProps) => {
  return (
    <Box
      data-testid="footer"
      sx={{ borderTop: `1px solid ${theme.colors.borderDark}` }}
      bg={bg}
      px={[3, 3, 10, 25]}
      pt={[0, 0, 1, 9]}
      pb={[6]}
    >
      {children ? (
        <Flex
          flexDirection={['column', 'column', 'column', 'row']}
          justifyContent="space-between"
          mb={[5, 5, 5, 8]}
        >
          {children}
        </Flex>
      ) : null}
      {renderContact && <Box mb={[3, 3, 3, 5]}>{renderContact()}</Box>}
      {renderSocial && (
        <Box
          sx={{
            display: ['block', 'block', 'block', 'none'],
            fontSize: ['26px', '26px', '26px', '22px'],
            mb: [2],
          }}
        >
          {renderSocial()}
        </Box>
      )}
      <StyledLegal
        sx={{
          pt: [2],
        }}
        justifyContent="space-between"
        alignItems={['center']}
      >
        {renderLegal && (
          <StyledLegalLinks
            data-id="Styled_Legal"
            alignItems={[
              'flex-start',
              'flex-start',
              'flex-start',
              'flex-start',
              'center',
            ]}
            flexDirection={['column', 'column', 'column', 'column', 'row']}
          >
            <Text size="tiny" mb={[2, 2, 2, 2, 0]}>
              All rights reserved © {new Date().getFullYear()} Singita
            </Text>
            <Box
              mx={[2]}
              sx={{ display: ['none', 'none', 'none', 'none', 'block'] }}
            >
              <Icon name="dot" size={6} sx={{ color: 'textDark' }} />
            </Box>
            {renderLegal()}
          </StyledLegalLinks>
        )}
        {renderSocial && (
          <Box
            data-id="Social_Large"
            sx={{
              display: ['none', 'none', 'none', 'block'],
              fontSize: ['26px', '26px', '26px', '22px'],
              alignItems: ['center', 'center', 'center', 'flex-end'],
              pl: [3],
            }}
          >
            {renderSocial()}
          </Box>
        )}
      </StyledLegal>
      {renderPPM && (
        <Box pt={[0, 0, 0, 1]} pb={[4]}>
          {renderPPM()}
        </Box>
      )}
    </Box>
  );
};

export default Footer;
